import React from 'react'
import Media from 'react-media'
import PropTypes from 'prop-types'
import { Link, Head } from 'react-static'
import ContactForm from '../ContactForm'
import Header from '../Header'
import Burger from '../Burger'
import DropdownMenu from '../DropdownMenu'
import Footer from '../Footer'

import logo from '../../images/logo-horizontal-white.png'
import phone from '../../images/icons/telephone-dark.png'

import '../../styles/contact/contact.scss'

export default class Contact extends React.Component {
  static propTypes = {
    burgerToggled: PropTypes.bool,
    toggleBurger: PropTypes.func,
  }

  state = { burgerToggled: false, show: false }

  componentWillMount () {
    if (this.props.burgerToggled) {
      this.props.toggleBurger()
    }
  }

  componentDidMount () {
    window.scroll(0, 0)
    
    if (typeof window !== undefined) {
      this.setState({ show: true })
    }
  }

  toggleBurger = () => {
    this.setState({ burgerToggled: !this.state.burgerToggled })
  }

  render () {
    const { burgerToggled, show } = this.state
    return (
      <div className="contact">
        <Head>
          <title>Contact</title>
          <meta description="Contact Makuch Roofing to discuss your roofing requirements. Phone 0274 284 027. Email jonathan@makuchroofing.co.nz or fill out the contact form." />
          <link rel="canonical" href="https://makuchroofing.co.nz/contact" />
        </Head>
        <Header className="blog-header">
          <Link to="/">
            <img className="header__logo" src={logo} alt="Makuch Roofing Logo" />
          </Link>
          <Burger click={this.toggleBurger} toggled={burgerToggled} />
        </Header>
        <DropdownMenu active={burgerToggled}>
          <Link to="/">Home</Link>
          <Link to="/blog">Blog</Link>
        </DropdownMenu>
        <div className="contact__title">
          <h2>Contact Us</h2>
        </div>
        <div className="contact-outer">
          <div className="contact-inner">
            <h5>CONTACT US</h5>
            <p>We&apos;d love to chat with you about your next roofing project. To get in touch just fill out the contact form or give us a call.</p>
            <div className="contact__phone">
              { show &&
              <Media query="(pointer: fine)">
                { matches => (matches
                  ?	<button className="default-button">
                    <img src={phone} alt="phone" /><span>0274 284 027</span>
                  </button>
                  : <a href="tel:0274284027">
                    <button className="default-button">
                      <img src={phone} alt="phone" /><span>0274 284 027</span>
                    </button>
                  </a>) }
              </Media>}
            </div>
            <ContactForm isContact />
          </div>
        </div>
        <Footer homeLink />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/contact-page/Contact.js